import * as React from "react";
import Otp from "consent/utils/otp";
import {ConsentBox} from "consent/utils/consentBox";
import {useEffect, useState} from "react";
import {imageBaseUrl} from "config";
import IconButton from "components/iconButton";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import {ILoanApprovalInfo, IOppSubstatus} from "StateInterface";
import {finishDelay, getUnSignedDoc, sendOtp, verifyOtp} from "consent/actions";
import {handleConsentNavigation} from "consent/route";
import {setRoute} from "consent";
import {RouteComponentProps} from "react-router-dom";
import RoundedButton from "components/roundedButton";
import {downloadPDF} from "utils/download";
import {partnerOfferings} from "login/config";

interface IConnectProps {
    loanApprovalInfo: ILoanApprovalInfo;
    userId: number;
    unsignedDocument: string;
    dispatch?: (action: any) => void;
    esignResponse: boolean;
    isAndroid: boolean;
    isPartnerAndroid: boolean;
    version: number;
    esignRequestId: string;
    utm_source: string;
    addDelay: Object;
}

type FinalProps = IConnectProps & RouteComponentProps;
const OTP_LENGTH = 6;
const Esign = (props: FinalProps) => {
    const [otp, updateOtp] = useState([]);
    const handleOnRequestOtp = () => {
        const timer = setInterval(() => {
            if (props.loanApprovalInfo) {
                clearInterval(timer);
                if (props.loanApprovalInfo.subStatuses.includes(IOppSubstatus.SHUBHSIGN_PENDING)) {
                    props.esignRequestId && props.dispatch(sendOtp(props.esignRequestId));
                } else {
                    handleConsentNavigation(setRoute(props.loanApprovalInfo, props.unsignedDocument, props.location, false));
                }
            }
        }, 500);
    };
    useEffect(() => {
        props.esignRequestId && !props.unsignedDocBase64Str && props.dispatch(getUnSignedDoc(props.esignRequestId));
        handleOnRequestOtp();
    }, [props.esignRequestId]);
    useEffect(() => { 
        if (props.esignResponse === false && otp.length > 0) {
            updateOtp([]);
        }
    }, [props.esignResponse]);
    useEffect(() => {
        if (props.addDelay) {
            setTimeout(() => {
                props.dispatch(finishDelay(props.addDelay))
            }, 10000)
        }
    }, [props.addDelay])
    const handleOnSubmitOtp = () => {
        const otpNumber = Number(otp.toString().replace(/,/g, ""));
        props.dispatch(verifyOtp(props.esignRequestId, otpNumber));
    };
    const downloadAgreement = async () => {
       await downloadPDF(props.unsignedDocument, "LoanAgreement", (props.isAndroid && !props.isPartnerAndroid));
    };
    const handleOtpUpdate = (newOtp: string[]) => {
        const updatedOtp = newOtp.map((value) => {
           return value;
        });
        updateOtp(updatedOtp);
    };
    return (
        <ConsentBox pageTitle={"Sign your Loan Agreement"}>
            <div className="flex-column-center-row">
                <div style={{marginLeft: 11, marginBottom: 15}}>
                    <img src={`${imageBaseUrl}/img/consent/contract.png`}
                         alt="contract"
                         style={{width: 108, height: 108}}/>
                </div>
                <IconButton
                    bgColor={partnerOfferings[props.utm_source]?.colors?.green}
                    buttonText="Download Agreement"
                    iconUrl={`${imageBaseUrl}/img/consent/download_icon.png`}
                    onClick={() => downloadAgreement()}
                />
                <div style={{marginTop: 25, marginBottom: 10, fontSize: 12, textAlign: "center"}}>
                    Enter the Verification Code sent to your mobile number
                </div>
                <Otp otp={otp}
                     otpLength={OTP_LENGTH}
                     otpType={"number"}
                     updateOtp={(newUpdatedOtp) => handleOtpUpdate(newUpdatedOtp)}
                     resendOtp={() => handleOnRequestOtp()}/>
                {props.esignResponse === false ?
                    <div className="alert alert-danger" style={{fontSize: 12, marginTop: 5}}>
                        E-Sign failed. Please enter correct OTP.
                    </div> : null}
                <div className="flex-center-row" style={{marginTop: 5, width: "100%"}}>
                    <RoundedButton
                        bgColor={partnerOfferings[props.utm_source]?.colors?.green}
                        buttonText="Verify"
                        isDisabled={otp.filter((value) => value !== "").length !== OTP_LENGTH}
                        size="small"
                        onClick={() => handleOnSubmitOtp()}
                    />
                </div>
            </div>
        </ConsentBox>
    );
};

const mapStateToProps = (state: IReduxState): IConnectProps => {
    return {
        loanApprovalInfo: state.consent.loanApprovalInfo,
        unsignedDocument: state.consent.unsignedDocBase64Str,
        userId: state.login.auth.userId,
        esignResponse: state.consent.esignResponse,
        isAndroid: state.login.isAndroid,
        isPartnerAndroid: state.login.isPartnerAndroid,
        version: state.login.apiVersion,
        esignRequestId: state.consent.loanApprovalInfo ? state.consent.loanApprovalInfo.esignRequestId : null,
        utm_source: state.login.authExt ? state.login.authExt.utm_source : null,
        addDelay: state.consent.addDelay,
    };
};
export default connect<IConnectProps, {}, {}>(mapStateToProps)(Esign);
